import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=6605514c&scoped=true&lang=html&"
import script from "./DetailsPanel.vue?vue&type=script&lang=js&"
export * from "./DetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=6605514c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605514c",
  null
  
)

export default component.exports